export interface FilterState {
  genre: string;
  region: string;
  year: string;
  sort: string;
}

interface FilterPanelProps {
  genres: string[];
  regions: string[];
  years: string[];
  value: FilterState;
  onChange: (patch: Partial<FilterState>) => void;
  onReset: () => void;
}

const sortOptions = [
  { key: 'hot', label: '按热度' },
  { key: 'latest', label: '按最新' },
];

function Group({
  title,
  options,
  active,
  onPick,
}: {
  title: string;
  options: string[];
  active: string;
  onPick: (v: string) => void;
}) {
  return (
    <div className="border-t border-background-200/70 py-4 first:border-t-0 first:pt-0">
      <h3 className="mb-3 text-sm font-semibold text-foreground-900">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onPick(opt)}
            className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
              active === opt
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700'
            }`}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({
  genres,
  regions,
  years,
  value,
  onChange,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-equalizer-line text-primary-500" />
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="cursor-pointer whitespace-nowrap text-xs font-medium text-foreground-500 transition-colors hover:text-primary-600"
        >
          <i className="ri-refresh-line mr-1" />
          重置
        </button>
      </div>

      <Group
        title="上传年份"
        options={['全部', ...years]}
        active={value.year}
        onPick={(v) => onChange({ year: v })}
      />
      <Group
        title="细分类型"
        options={['全部', ...genres]}
        active={value.genre}
        onPick={(v) => onChange({ genre: v })}
      />
      <Group
        title="地区"
        options={['全部', ...regions]}
        active={value.region}
        onPick={(v) => onChange({ region: v })}
      />
      <div className="border-t border-background-200/70 py-4 last:pb-0">
        <h3 className="mb-3 text-sm font-semibold text-foreground-900">排序方式</h3>
        <div className="flex flex-wrap gap-2">
          {sortOptions.map((s) => (
            <button
              key={s.key}
              type="button"
              onClick={() => onChange({ sort: s.key })}
              className={`cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
                value.sort === s.key
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-accent-100 hover:text-accent-700'
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}